import { useState } from "react";
import { HeroSectionProps } from "../types";
import { XHtml } from "@/components/xhtml";

const themeClasses = {
    Blue: "bg-brand-detail-blue-light ",
    Red: "bg-brand-pink  text-support-blue",
    Gray: "bg-brand-gray text-blue-900",
} as const;

export function HeroSection({
    headerColor,
    hero,
}: HeroSectionProps) {
    const [activeHero, setActiveHero] = useState(0);



    if (!hero || hero.length === 0) return null;


    const theme = themeClasses[headerColor];

    return (
        <>
            {hero.length >= 1 && (
                <section
                    className={`${theme}  px-4 sm:px-4 md:px-10 lg:px-20 pt-5 pb-10 overflow-hidden w-full max-w-[100vw]`}
                >
                    <div className="w-full overflow-x-auto">
                        <div className="flex justify-center md:justify-center">
                            <div className={`flex rounded-full overflow-hidden border bg-brand-support-blue text-white`}>
                                {hero.map((h, i) => (
                                    <button
                                        key={i}
                                        onClick={() => setActiveHero(i)}
                                        className={`${activeHero === i ? "bg-brand text-white" : "bg-white text-brand"} flex-1 px-4 sm:px-5 py-2 text-sm md:text-base border-r last:border-r-0 `}
                                        aria-pressed={activeHero === i}
                                    >
                                        <p className="!mb-0 text-center">{h.heroTitle}</p>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <section className={`${theme} px-4 sm:px-4 md:px-10 lg:px-20 pb-10`}>
                <div className="relative min-h-[400px] md:min-h-[400px] lg:min-h-[400px]">
                    {hero.map((h, i) => (
                        <article
                            key={`panel-${i}`}
                            className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${activeHero === i ? "opacity-100 visible" : "opacity-0 invisible"
                                } flex flex-col md:flex-row gap-0 md:gap-20 lg:gap-20`}
                        >
                            {h.source && (
                                <div className="flex items-start md:items-center py-0 md:py-10">
                                    <div className="w-[200px] h-[200px] md:w-[400px] md:h-[400px] rounded-full overflow-hidden shrink-0">
                                        <img
                                            src={h.source}
                                            alt={h.alt || ""}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="flex flex-col gap-5 md:gap-5 py-5 md:py-10">
                                {h.contentTitle && (
                                    <h2 className="m-0 text-2xl md:text-3xl font-semibold">{h.contentTitle}</h2>
                                )}
                                {h.description && <XHtml xhtmlString={h.description} />}
                                {h.buttonLink && h.buttonText && (
                                    <a
                                        href={h.buttonLink}
                                        className="flex gap-2 items-center justify-center px-7 py-3 rounded-full bg-brand text-white w-max no-underline"
                                    >
                                        {h.buttonText} <span aria-hidden> &rarr;</span>
                                    </a>
                                )}
                            </div>
                        </article>
                    ))}
                </div>
            </section>
        </>
    );
}